export default __webpack_public_path__ + "static/media/ucy_koinwnikes_greek.3b4c6016.png";